import { MutableRefObject, useEffect } from 'react';

// eslint-disable-next-line no-unused-vars
export type OnViewportCallbackType = (onViewport: boolean, entry: IntersectionObserverEntry) => void;

const useOnViewport = (
  ref: MutableRefObject<any>,
  callback: OnViewportCallbackType,
  { disabled, options }: { disabled?: boolean; options?: any } = {},
) => {
  useEffect(() => {
    if (disabled || !ref.current) {
      return undefined;
    }
    const observer = new IntersectionObserver(([entry]) => {
      callback(entry.isIntersecting, entry);
    }, options);
    observer.observe(ref.current);
    return () => {
      observer.disconnect();
    };
  }, [ref, callback, disabled, options]);
};

export default useOnViewport;
